import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@shared/validators';
import { BaseComponent } from '@app/common/modules/base/base.component';
import { ActivatedRoute } from '@angular/router';
import { AlterarSenhaController } from '@modules/auth/controllers';

interface LoginType {
  name: 'cpf' | 'cnpj' | 'email';
  type: string;
  label: string;
  icon: string;
  mask: string;
}

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.scss'],
})
export class AlterarSenhaComponent extends BaseComponent {
  public loginForm: FormGroup;
  public passwordVisible = false;
  public isSubmitting = false;
  public isSubmitted = false;
  public hasError = false;
  public secret: string | null = null;

  constructor(
    private formBuilder: FormBuilder,
    public alterarSenhaController: AlterarSenhaController,
    private activatedRoute: ActivatedRoute
  ) {
    super('Alterar senha - Portal do Cliente');
    this.loginForm = this.createForm();
    this.secret = this.getSecret();
  }

  private createForm() {
    return this.formBuilder.group({
      senha: ['', [Validators.required]],
      confirmarSenha: ['', [Validators.required]],
    }, { validators: CustomValidators.confirmarSenha });
  }

  private getSecret() {
    const secret = this.activatedRoute.snapshot.queryParamMap.get('secret');

    if (!secret) {
      this.hasError = true;
      return null;
    }

    return secret;
  }

  public submit(): void {
    this.isSubmitting = true;

    if (this.loginForm.valid && this.secret) {
      const data = {
        senha: this.loginForm.value.senha,
        chave: this.secret,
      };

      this.alterarSenhaController.alterarSenha(data).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.isSubmitted = true;
        },
        error: () => {
          this.isSubmitting = false;
          this.hasError = true;
        }
      });
    }
  }
}
